import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import { Auth } from "aws-amplify";
import VueCookies from "vue-cookies";

// VueRouter
Vue.use(VueRouter);

// VueCookies
Vue.use(VueCookies);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/registerAndDonate",
    name: "RegisterAndDonate",
    component: () => import("../views/RegisterAndDonate.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/newOrder",
    name: "NewOrder",
    component: () => import("../views/Order/NewOrder.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/newOrderSummary",
    name: "NewOrderSummary",
    component: () => import("../views/Order/NewOrderSummary.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/orderStatus",
    name: "OrderStatus",
    component: () => import("../views/Status/OrderStatus.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/orderStatusSummary/",
    name: "OrderStatusSummary",
    component: () => import("../views/Status/OrderStatusSummary.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/requestRefund",
    name: "RequestRefund",
    component: () => import("../views/Status/RequestRefund.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/pendingRefund",
    name: "PendingRefund",
    component: () => import("../views/Status/PendingRefund.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/refundLogin",
    name: "RefundLogin",
    component: () => import("../views/Refund/RefundLogin.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/refundOverview",
    name: "RefundOverview",
    component: () => import("../views/Refund/RefundOverview.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/refundDetails",
    name: "RefundDetails",
    component: () => import("../views/Refund/RefundDetails.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/summaryReport",
    name: "SummaryReport",
    component: () => import("../views/Status/SummaryReport.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "/videoTutorials",
    name: "VideoTutorials",
    component: () => import("../views/VideoTutorials.vue"),
    beforeEnter: checkAuthenication,
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () => import("../views/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

async function checkAuthenication(to, from, next) {
  let isAuthenticated = await Auth.currentAuthenticatedUser().catch((error) => {
    next({ name: "Login", params: { errorMsg: error }, replace: true });
  });

  if (isAuthenticated) {
    if (
      (to.name == "RefundOverview" || to.name == "RefundDetails") &&
      !$cookies.get("tff_authenicateRefundLogin")
    ) {
      next({
        name: "Home",
        params: { errorMsg: "Not authenticated to view refunds" },
        replace: true,
      });
    } else if (to.name == "RefundDetails" && !localStorage.getItem("refund")) {
      next({
        name: "RefundOverview",
        params: { errorMsg: "Not authenticated to view refunds" },
        replace: true,
      });
    } else {
      next();
    }
  }
}

export default router;
